<form [formGroup]="partnerForm">
  <div class="dashboard-tile">
    <div class="tile-header">
      <div *ngIf="_partner?.id" class="tile-header-title">Update Integration Partner <span class="text-primary">{{_partner.name}}</span></div>
      <div *ngIf="!_partner?.id" class="tile-header-title">New Integration Partner</div>
    </div>
    <div class="tile-content">
      <div class="formFieldList">
        <mat-form-field>
          <input matInput placeholder="Name" formControlName="name" required>
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Partner Key" formControlName="partnerKey" required>
        </mat-form-field>
        <mat-form-field>
          <mat-select placeholder="Plan" formControlName="plan" required>
            <mat-option *ngFor="let pl of availablePlans" [value]="pl.id">{{pl.name}} (id: {{pl.id}})</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Application Url" formControlName="applicationUrl" required>
        </mat-form-field>
        <div fxLayout="row wrap" fxLayoutGap="20px">
          <button [disabled]="partnerForm.invalid" mat-raised-button type="submit" color="primary" (click)="saveIntegrationPartner()">Save</button>
          <button mat-raised-button type="button" color="primary" (click)="cancelIntegrationPartner()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</form>